export enum PasswordRequirementMessage {
    LowerUpperCase = 'At least 1 uppercase character',
    Number = 'At least 1 number',
    Length = `At least 8 characters`
}


// WEBPACK FOOTER //
// ./src/webportal/components/common/requirementManagers/errors/PasswordRequirementMessage.ts